import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faBook,
  faSignal,
  faUser as solidUser,
  faTruckMoving,
  faPlus,
  faSpinner,
  faRupeeSign,
  faStar,
  faCaretDown,
  faCaretUp,
  faTimes,
  faEye,
  faChartLine,
  faCogs,
  faCheck,
  faPhoneAlt,
  faChevronRight,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons';

import {
  faUser,
  faMap,
  faEdit,
  faFileWord,
  faSave,
  faStar as rStar
} from '@fortawesome/free-regular-svg-icons';

library.add(
  faUser,
  faMap,
  faBook,
  faSignal,
  solidUser,
  faTruckMoving,
  faEdit,
  faFileWord,
  faPlus,
  faSave,
  faSpinner,
  faRupeeSign,
  faStar,
  rStar,
  faCaretDown,
  faCaretUp,
  faTimes,
  faEye,
  faChartLine,
  faCogs,
  faCheck,
  faPhoneAlt,
  faChevronRight,
  faTimesCircle
);
